<template>
<div class="cicket-detail">
  <div class="go-back">
    <p onclick="history.go(-1)">
      <i class="el-icon-arrow-left"></i>
      <span>{{ $route.query.sj }}</span>
    </p>
    <p style="color: #8c8c8c;">{{  $route.query.time }}</p>
  </div>
  <ul class="selectvideo">
    <li :class="videoUrl ? '_v' : '_k'" @click="handleclickUrl(videoUrl)">
      <video loop="loop" controls preload width="100%" height="100%">
        <source :src="videoUrl" type="video/mp4">
      </video>
    </li>
    <li :class="videoUrl ? '_noTitle' : '_tit'">
      <p class="_sj">{{  $route.query.name }}</p>
        <div class="team_logo">
          <div class="resertImgbg">
            <p><img :src="h_img" alt width="auto" height="100%" :onerror="errorImg02"/></p>
            <span>{{ $route.query.hTeam}}</span>
          </div>
          <div class="start_time">
            <p class="middle_time_02">
              <template v-if="$route.query.matchStatus == 'not_started'"> Start Time</template>
              <template v-else> <span> V </span></template>
            </p>
            <p class="middle_time">
              <template v-if="$route.query.matchStatus == 'not_started'">{{ changeIndiaTimeagain($route.query.startDate) }}</template>
              <template v-else><span>{{ $route.query.hFull }} : {{ $route.query.gFull }}</span></template>
            </p>
          </div>
          <div class="resertImgbg">
            <p><img :src="g_img" alt width="auto" height="100%" :onerror="errorImg01"/></p>
            <span>{{ $route.query.gTeam}}</span>
          </div>
       </div>
    </li>
  </ul> 
</div>

</template>
<script>
import { filter } from "@/common/index";
import { parseTime } from "@/common/utils/Date.js";
import { mapState } from 'vuex';
export default {
  props:{
    videoUrl:{
      type:String,
      required:false
    }
  },
  computed:{
     ...mapState({
       staticDomain: state => state.linkList.staticDomain
     }),
     h_img(){ 
       return this.staticDomain + '/team/' + this.$route.query.srHTeam +'.png'
     },
     g_img(){
        return this.staticDomain + '/team/' + this.$route.query.srGTeam +'.png'
     }
   },
   data(){
     return{
      errorImg01: 'this.src="' + require('../img/h_teams.png') + '"',
      errorImg02:'this.src="' + require('../img/g_teams.png') + '"',
     }
   },
   methods:{
     changeIndiaTimeagain(val){ return filter.getTimehms(parseTime(val))},
     handleclickUrl(url){
       window.open(url)
     }
   }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1500px){
  ._tit {
    font-size: 20px!important;
    .team_logo{ width:90%!important;}
    .resertImgbg{
      span{ font-size: 14px!important;}
    }
    .start_time{
      .middle_time_02{ span{ font-size: 18px;}}
    }
  }
}
.cicket-detail{
  .go-back{
    height: 50px;
    background-color: #fff;
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding:0 15px;
    font-family: Roboto-Black;
	  font-size: 16px;
    color: #222;
    border-radius: 6px 6px 0 0;
    font-weight: 550;
    i{
      cursor: pointer;
      display:inline-block;
      width:30px;
      height:100%;
      font-size:28px;
      vertical-align: middle;
    }
  }
  .selectvideo{
    height:246px;
    margin-bottom:10px;
    overflow: hidden;
    display:flex;
    justify-content: space-between;
    li{
      &._v{  width:32%; }
      &._k{ width:0;}
      &._noTitle{ width:68%; .team_logo{ width:80% } }
      &._tit{ width:100%;.team_logo{ width:62% } }
      &._tit,&._noTitle{
        font-family: Roboto-Black;
	      font-size: 24px;
        color: #000;
        font-weight: 550;
        // background-color: #daecb8;
        background-image:url('../img/detail_bg.png');
        background-size:cover;
        ._sj{ text-align: center;padding: 30px 0 18px;line-height: 26px;}
        .team_logo{
          display:flex;
          // justify-content: center;
          justify-content: space-around;
          align-items: center;
          margin:0 auto;
          text-align: center;
          .resertImgbg{
            width: 170px;
            height: 130px;
            background-color: rgba(255,255,255,.8);
            border-radius: 20px;
            p{ margin:18px auto 0;height:45px;}
            span{
              display:inline-block;
              text-align: center;
              font-size: 16px;
              word-wrap:break-word;
              padding-top:10px;
              padding-right:10px;
              padding-left:10px;
            }
          }
        }
        .start_time{ 
          padding:0 10px;
          .middle_time_02{ font-size: 16px; span{ font-size:24px;}}
          .middle_time{
            font-size: 30px;
            margin-top:8px;
            span{
              font-size: 24px;
              border-radius:6px;
              display:inline-block;
              min-width:120px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/new-home/M-contnt/index.vue